var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_297_173)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_297_173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 6.30273C44.3516 6.30273 45.459 6.34375 49.1367 6.50781C52.5547 6.6582 54.4004 7.23242 55.6309 7.71094C57.2578 8.33984 58.4336 9.10547 59.6504 10.3223C60.8809 11.5527 61.6328 12.7148 62.2617 14.3418C62.7402 15.5723 63.3145 17.4316 63.4649 20.8359C63.6289 24.5273 63.6699 25.6348 63.6699 34.9727C63.6699 44.3242 63.6289 45.4316 63.4649 49.1094C63.3145 52.5274 62.7402 54.3731 62.2617 55.6035C61.6328 57.2305 60.8672 58.4063 59.6504 59.6231C58.4199 60.8535 57.2578 61.6055 55.6309 62.2344C54.4004 62.7129 52.541 63.2871 49.1367 63.4375C45.4453 63.6016 44.3379 63.6426 35 63.6426C25.6484 63.6426 24.541 63.6016 20.8633 63.4375C17.4453 63.2871 15.5996 62.7129 14.3691 62.2344C12.7422 61.6055 11.5664 60.8398 10.3496 59.6231C9.11914 58.3926 8.36719 57.2305 7.73828 55.6035C7.25977 54.3731 6.68555 52.5137 6.53516 49.1094C6.37109 45.418 6.33008 44.3106 6.33008 34.9727C6.33008 25.6211 6.37109 24.5137 6.53516 20.8359C6.68555 17.418 7.25977 15.5723 7.73828 14.3418C8.36719 12.7148 9.13281 11.5391 10.3496 10.3223C11.5801 9.0918 12.7422 8.33984 14.3691 7.71094C15.5996 7.23242 17.459 6.6582 20.8633 6.50781C24.541 6.34375 25.6484 6.30273 35 6.30273ZM35 0C25.498 0 24.3086 0.0410156 20.5762 0.205078C16.8574 0.369141 14.3008 0.970703 12.0859 1.83203C9.77539 2.73438 7.82031 3.92383 5.87891 5.87891C3.92383 7.82031 2.73438 9.77539 1.83203 12.0723C0.970703 14.3008 0.369141 16.8438 0.205078 20.5625C0.0410156 24.3086 0 25.498 0 35C0 44.502 0.0410156 45.6914 0.205078 49.4238C0.369141 53.1426 0.970703 55.6992 1.83203 57.9141C2.73438 60.2246 3.92383 62.1797 5.87891 64.1211C7.82031 66.0625 9.77539 67.2656 12.0723 68.1543C14.3008 69.0156 16.8438 69.6172 20.5625 69.7812C24.2949 69.9453 25.4844 69.9863 34.9863 69.9863C44.4883 69.9863 45.6777 69.9453 49.4102 69.7812C53.1289 69.6172 55.6856 69.0156 57.9004 68.1543C60.1973 67.2656 62.1523 66.0625 64.0938 64.1211C66.0352 62.1797 67.2383 60.2246 68.127 57.9277C68.9883 55.6992 69.5899 53.1563 69.7539 49.4375C69.918 45.7051 69.959 44.5156 69.959 35.0137C69.959 25.5117 69.918 24.3223 69.7539 20.5898C69.5899 16.8711 68.9883 14.3145 68.127 12.0996C67.2656 9.77539 66.0762 7.82031 64.1211 5.87891C62.1797 3.9375 60.2246 2.73438 57.9277 1.8457C55.6992 0.984375 53.1563 0.382813 49.4375 0.21875C45.6914 0.0410156 44.502 0 35 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.23123 6.23371L6.23122 6.2337C4.33063 8.121 3.1775 10.0153 2.2979 12.2538C1.45811 14.427 0.866466 16.9157 0.704599 20.5844L6.23123 6.23371ZM6.23123 6.23371L6.2337 6.23122M6.23123 6.23371L6.2337 6.23122M6.2337 6.23122C8.12111 4.33051 10.0153 3.1775 12.2674 2.29793C14.4262 1.45845 16.9283 0.8665 20.5981 0.704596C24.3197 0.541011 25.5007 0.5 35 0.5C44.4995 0.5 45.6796 0.541019 49.4138 0.718191L49.4155 0.718264C53.0849 0.88015 55.5738 1.47198 57.7473 2.31202C59.9832 3.17709 61.8783 4.34319 63.7675 6.23246L63.7688 6.2337C65.6696 8.12117 66.8206 10.0135 67.6581 12.2734L67.6581 12.2734M6.2337 6.23122L67.6581 12.2734M6.23122 63.7663L6.23246 63.7675C8.12173 65.6568 10.0168 66.8229 12.2527 67.688C14.4261 68.528 16.9151 69.1198 20.5845 69.2817C20.5845 69.2817 20.5845 69.2817 20.5845 69.2817L20.5625 69.7812C24.2949 69.9453 25.4844 69.9863 34.9863 69.9863L6.23122 63.7663ZM6.23122 63.7663C4.33059 61.879 3.17759 59.9848 2.29803 57.7328C1.4585 55.574 0.86651 53.0719 0.704596 49.4019C0.541011 45.6803 0.5 44.4994 0.5 35C0.5 25.5008 0.541009 24.3197 0.704592 20.5845L6.23122 63.7663ZM67.6581 12.2734L67.6609 12.2808M67.6581 12.2734L67.6609 12.2808M67.6609 12.2808C68.5005 14.4396 69.0925 16.9418 69.2544 20.6118L67.6609 12.2808ZM35 5.80273C44.3541 5.80273 45.4703 5.84376 49.1587 6.0083L35 5.80273ZM35 5.80273C25.6457 5.80273 24.5297 5.84376 20.841 6.00831C17.3813 6.16117 15.4683 6.74704 14.1883 7.24477C12.4976 7.89842 11.2763 8.68843 9.99606 9.96871C8.72976 11.235 7.92592 12.4698 7.27212 14.161C6.77448 15.4407 6.18852 17.34 6.03565 20.8137C5.8711 24.5023 5.83008 25.6183 5.83008 34.9727C5.83008 44.3134 5.8711 45.4293 6.03565 49.1316M35 5.80273L6.03565 49.1316M55.8117 7.24477C57.5029 7.89858 58.7377 8.70242 60.0039 9.96871C61.2842 11.2489 62.0742 12.4701 62.7278 14.1608M55.8117 7.24477L62.2617 14.3418M55.8117 7.24477C54.532 6.74714 52.6327 6.16118 49.159 6.00831L55.8117 7.24477ZM62.7278 14.1608C62.7279 14.161 62.728 14.1613 62.7281 14.1615L62.2617 14.3418M62.7278 14.1608C62.7278 14.1607 62.7278 14.1606 62.7277 14.1606L62.2617 14.3418M62.7278 14.1608C63.2256 15.4408 63.8115 17.3538 63.9644 20.8137M62.2617 14.3418C62.7402 15.5723 63.3145 17.4316 63.4649 20.8359M63.9644 20.8137L63.4649 20.8359M63.9644 20.8137C63.9644 20.8138 63.9644 20.8138 63.9644 20.8139L63.4649 20.8359M63.9644 20.8137L63.4649 20.8359M6.03565 49.1316C6.1885 52.5914 6.77438 54.5044 7.27212 55.7843L6.03565 49.1316ZM63.9644 49.1317C63.9644 49.1316 63.9644 49.1315 63.9644 49.1314L63.4649 49.1094L63.9644 49.1317ZM62.7278 55.7845C62.7279 55.7843 62.728 55.784 62.7281 55.7838L62.2617 55.6035L62.7277 55.7847C62.7278 55.7847 62.7278 55.7846 62.7278 55.7845ZM55.8119 62.7005C55.8119 62.7004 55.812 62.7004 55.8121 62.7004L55.6309 62.2344L55.8111 62.7008C55.8114 62.7007 55.8116 62.7006 55.8119 62.7005ZM49.1589 63.937L49.1367 63.4375L49.1588 63.937C49.1588 63.937 49.1589 63.937 49.1589 63.937ZM20.841 63.937C20.8411 63.937 20.8412 63.937 20.8413 63.937L20.8633 63.4375L20.841 63.937ZM14.1881 62.7005C14.1884 62.7006 14.1886 62.7007 14.1889 62.7008L14.3691 62.2344L14.1879 62.7004C14.188 62.7004 14.1881 62.7004 14.1881 62.7005Z",
    stroke: "#CB37FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_297_173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 17.0215C25.0742 17.0215 17.0215 25.0742 17.0215 35C17.0215 44.9258 25.0742 52.9785 35 52.9785C44.9258 52.9785 52.9785 44.9258 52.9785 35C52.9785 25.0742 44.9258 17.0215 35 17.0215ZM35 46.6621C28.5605 46.6621 23.3379 41.4395 23.3379 35C23.3379 28.5605 28.5605 23.3379 35 23.3379C41.4395 23.3379 46.6621 28.5605 46.6621 35C46.6621 41.4395 41.4395 46.6621 35 46.6621Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5215 35C17.5215 25.3504 25.3504 17.5215 35 17.5215C44.6496 17.5215 52.4785 25.3504 52.4785 35C52.4785 44.6496 44.6496 52.4785 35 52.4785C25.3504 52.4785 17.5215 44.6496 17.5215 35ZM22.8379 35C22.8379 41.7156 28.2844 47.1621 35 47.1621C41.7156 47.1621 47.1621 41.7156 47.1621 35C47.1621 28.2844 41.7156 22.8379 35 22.8379C28.2844 22.8379 22.8379 28.2844 22.8379 35Z",
    stroke: "#CB37FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_297_173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.8867 16.3106C57.8867 18.6348 56 20.5078 53.6895 20.5078C51.3652 20.5078 49.4922 18.6211 49.4922 16.3106C49.4922 13.9863 51.3789 12.1133 53.6895 12.1133C56 12.1133 57.8867 14 57.8867 16.3106Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3867 16.3106C57.3867 18.3576 55.7249 20.0078 53.6895 20.0078C51.6424 20.0078 49.9922 18.346 49.9922 16.3106C49.9922 14.2635 51.654 12.6133 53.6895 12.6133C55.7239 12.6133 57.3867 14.2761 57.3867 16.3106Z",
    stroke: "#CB37FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_297_173",
    x: -9.7,
    y: -9.7,
    width: 89.359,
    height: 89.3863,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.85
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.79627 0 0 0 0 0.216423 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_297_173"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_297_173",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_297_173",
    x: 3.62148,
    y: 3.62148,
    width: 62.757,
    height: 62.757,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.79627 0 0 0 0 0.216423 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_297_173"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_297_173",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_297_173",
    x: 42.1922,
    y: 4.81328,
    width: 22.9945,
    height: 22.9945,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.65
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.79627 0 0 0 0 0.216423 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_297_173"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_297_173",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_297_173"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.aa0ac29b1f5a09ac20469e49a13cef3f.svg";
export { ForwardRef as ReactComponent };